export default "__VITE_ASSET__D_amj4Op__"